import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { DonationCardService } from '../../services/donation-card.service';
import { Chart, registerables } from "chart.js"
import annotationPlugin from 'chartjs-plugin-annotation';
import { DonorCardService } from '../../services/donor-card.service';
import { SkeletonModule } from 'primeng/skeleton';

Chart.register(...registerables, annotationPlugin);

@Component({
  selector: 'app-current-cycle-donations',
  templateUrl: './current-cycle-donations.component.html',
  styleUrls: ['./current-cycle-donations.component.scss'],
  standalone: true,
  imports: [CommonModule, CardModule, ChartModule, SkeletonModule],
  providers: [DonationCardService, DonorCardService]
})
export class CurrentCycleDonationsComponent implements OnInit {
  @Input() donationId: number = 0;
  @Input() campaignId: number = 0;
  @Input() donorId: number = 0;

  donorCurrentCycleDonations: any = null;
  donorCurrentCycleDonationsChartData: any;
  donorCurrentCycleDonationsChartOptions: any;

  constructor(private donationCardService: DonationCardService,
              private donorCardService: DonorCardService
  ) { }

  ngOnInit(): void {
    this.loadCurrentCycleDonations();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['donationId']
        || changes['donorId']
        || changes['campaignId']
    ) {
      this.loadCurrentCycleDonations();
    }
  }

  loadCurrentCycleDonations(): void {
    if (this.donationId)
    {
      this.donationCardService.getCurrentCycleDonations(this.donationId).subscribe({
        next: data => {
          this.loadCurrentCycleDonatoinsChartData(data);
        },
        error: err => {
          console.error('Unable to retrieve current cycle donations. Please try again later.', err);
        }
      });
    }
    else if (this.campaignId && this.donorId)
    {
      this.donorCardService.getCurrentCycleDonations(this.campaignId, this.donorId).subscribe({
        next: data => {
          this.loadCurrentCycleDonatoinsChartData(data);
        },
        error: err => {
          console.error('Unable to retrieve current cycle donations. Please try again later.', err);
        }
      });

    }
  }

  loadCurrentCycleDonatoinsChartData(data: any)
  {
    this.donorCurrentCycleDonations = data;

    this.donorCurrentCycleDonationsChartData = {
      labels: this.donorCurrentCycleDonations.monthlyDonations.map((ds: any) => ds.label),
      datasets: [
        {
          label: "Donation Amount",
          data: this.donorCurrentCycleDonations.monthlyDonations.map((ds: any) => ds.runningTotal),
          backgroundColor: [
            '#8C261D'
          ],
          order: 1
        }
      ]
    };

    this.donorCurrentCycleDonationsChartOptions = {
      plugins: {
        annotation: {
          annotations: {
            line1: {
              type: 'line',
              label: {
                content: 'Campaign Limit',
                display: true,
                backgroundColor: '#ffffff',
                color: '#000000'
              },
              yMin: this.donorCurrentCycleDonations.campaignLimit,
              yMax: this.donorCurrentCycleDonations.campaignLimit,
              borderColor: 'rgb(255, 99, 132)',
              borderWidth: 2,
              borderDash: [9,3]
            }
          }
        }
      },
      scales: {
        y: {
          suggestedMax: this.donorCurrentCycleDonations.campaignLimit + 150,
        }
      }
    };
  }
}
